export default __webpack_public_path__ + "static/media/Image gallery element(4).90f5c8de.png";